import { Directive, Input } from '@angular/core';

@Directive()
export abstract class AbstractTailoredBasicWidget<T extends {}> {
    @Input() config!: T;

    @Input() context!: Record<string, any>;
}
